// extracted by mini-css-extract-plugin
export default {"pdfDocument":"styles_pdfDocument__Gfd8+","pdfPage":"styles_pdfPage__xYgK4"};